import { Outlet } from "react-router-dom"

const AdminStudiesScreen = () => {
  return (
    <>
      <Outlet />
    </>
  )
}

export default AdminStudiesScreen
